import { listCarPictures } from '../../config';

const checkImagePath = async (path) => {
  const imageHautQuality = new Promise((resolve) => {
    listCarPictures.forEach((id) => {
      if (path.split(/[.]+/).includes(id)) resolve(true);
    });
    resolve(false);
  });
  return imageHautQuality;
};

export default checkImagePath;
